import { render, staticRenderFns } from "./PowerDrops.vue?vue&type=template&id=511757d3&"
import script from "./PowerDrops.vue?vue&type=script&lang=js&"
export * from "./PowerDrops.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BContainer} from 'bootstrap-vue'
    installComponents(component, {BContainer})
    

export default component.exports